module.exports = __webpack_public_path__ + "img/team7.703094cd.png";